import { PRIVATE_PARTY_FEES, privatePartyPackages } from "../data/packages";

// This inquiry estimate excludes optional add-ons and payment fees.
export function calculatePrivatePartyEstimate(packageId, kids, adults) {
  const pkg = privatePartyPackages.find(
    (item) => String(item.id) === String(packageId),
  );
  if (!pkg) throw new Error("Select a private birthday party package.");

  const validCount = (count) =>
    count !== "" &&
    count !== null &&
    count !== undefined &&
    Number.isSafeInteger(Number(count)) &&
    Number(count) >= 0;
  if (!validCount(kids) || !validCount(adults)) {
    throw new Error("Guest counts must be non-negative whole numbers.");
  }

  const additionalKids = Math.max(0, Number(kids) - pkg.includedKids);
  const additionalAdults = Math.max(0, Number(adults) - pkg.includedAdults);
  const additionalKidsCents =
    additionalKids * PRIVATE_PARTY_FEES.additionalKid * 100;
  const additionalAdultsCents =
    additionalAdults * PRIVATE_PARTY_FEES.additionalAdult * 100;
  const subtotalCents =
    pkg.price * 100 + additionalKidsCents + additionalAdultsCents;
  // The existing policy taxes the total balance; round tax once, to the cent.
  const taxCents = Math.round(subtotalCents * PRIVATE_PARTY_FEES.taxRate);

  return {
    additionalKids,
    additionalAdults,
    additionalKidsCharge: additionalKidsCents / 100,
    additionalAdultsCharge: additionalAdultsCents / 100,
    subtotal: subtotalCents / 100,
    // Keep the existing inquiry field compatible with external email templates.
    serviceFee: 0,
    tax: taxCents / 100,
    estimate: (subtotalCents + taxCents) / 100,
  };
}
